const removeCSSClass = ( id: string ): void => {
    const el: HTMLElement | null   = document.getElementById( id )
    if( el) el.remove()
}
export default  removeCSSClass